/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Box } from '@mui/material';

import MessageList from './MessageList'
import { changeToNumber } from '../../actions'
import { MESSAGE_PING } from '../../constants'
import { useSelector } from 'react-redux';

export default function Dashboard({socket}) {
    const { to } = useSelector(state => state.number)

    const [messages, setMessages] = useState([])

    const alertSound = new Audio(MESSAGE_PING)

    useEffect(()=> {
        // Once loaded sends message to socket waiting for response
        if (socket.readyState === 1) {
            socket.send('Connected')
        }
    }, [])

    socket.onmessage = (e) => {
        setMessages(JSON.parse(e.data))
    }

    return (
        <Box
            container
            boxShadow={3}
            spacing={3}
            sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', width: '39vw', height: '86vh' }}
        >

            <MessageList 
            messages={messages} 
            alertSound={alertSound} 
            activeNumber={to}
            changeToNumber={changeToNumber} 
            />
        </Box>
    )
}